module.exports = __webpack_public_path__ + "img/guozai_09.6ad6c2f4.jpg";